import axios from 'axios'

function getCookie(name) {
    if (document.cookie) {
        const cookies = document.cookie.split(';').map(c => c.trim())
        const cookie = cookies.find(c => c.startsWith(`${name}=`))
        if (cookie) {
            return cookie.substring(name.length + 1)
        }
    }
    return '' // no cookie found
}

export const post = async (url, data, config = {}) => {
    // wrapper around axios.post() that injects the header `X-CSRFToken` and the location origin
    config.headers = { 'X-CSRFToken': getCookie('csrftoken'), ...config.headers }
    return axios.post(`${window.location.origin}${url}`, data, config)
}

const patch = async (url, data, config = {}) => {
    // wrapper around axios.patch() that injects the header `X-CSRFToken` and the location origin
    config.headers = { 'X-CSRFToken': getCookie('csrftoken'), ...config.headers }
    return axios.patch(`${window.location.origin}${url}`, data, config)
}

export const login = async (email, password) => {
    return post('/users/login/', { email, password }, { headers: { 'Content-Type': 'application/json' } })
}

export const logout = async () => {
    return post('/users/logout/', {})
}

export const getUserInfo = async () => {
    const response = await axios.get(`${window.location.origin}/users/user-info/`)
    return response?.data
}

export const confirmPassword = async (token, password) => {
    return post('/users/password-tokens/confirm/', { token, password })
}

export const validateToken = async token => {
    return post('/users/password-tokens/validate_token/', { token })
}

export const createAccount = async (email, name) => {
    return post('/users/create-user/', { email, name })
}

export const resetPassword = async email => {
    return post('/users/reset-password/', { email })
}

export const listProjects = async () => {
    const response = await axios.get(`${window.location.origin}/saved_projects/`)
    return response?.data
}

export const createProject = async data => {
    return post('/saved_projects/', data)
}

export const updateProject = async (uuid, data) => {
    return patch(`/saved_projects/${uuid}/`, data)
}

export const deleteProject = async uuid => {
    return axios.delete(`${window.location.origin}/saved_projects/${uuid}/`, {
        headers: { 'X-CSRFToken': getCookie('csrftoken') }
    })
}

export const getProject = async uuid => {
    const response = await axios.get(`${window.location.origin}/saved_projects/${uuid}/`)
    return response?.data
}
